import { DeleteOutline } from '@mui/icons-material';
import { Grid, IconButton } from '@mui/material';
import PropTypes from 'prop-types';
import { useFieldArray, useFormContext, useWatch } from 'react-hook-form';
import { useSelector } from 'react-redux';
import AddMoreButton from '../AddMoreButton';
import StaffInfoInputs from './StaffInfoInputs';

StaffInfoInputsAddMore.propTypes = {
  fieldName: PropTypes.string,
  focusedField: PropTypes.string,
  setFocusedField: PropTypes.func,
  fieldAttributes: PropTypes.object,
  isEditable: PropTypes.bool,
};

export default function StaffInfoInputsAddMore({
  fieldName,
  focusedField,
  setFocusedField,
  fieldAttributes,
  isEditable,
}) {
  const { control, setValue } = useFormContext();
  const { fields, append, remove } = useFieldArray({
    control,
    name: fieldName,
    keyName: '_id',
  });
  const watchedValues = useWatch({ control, name: fieldName }) || [];
  const isCanceled = useSelector((state) => state.transitions?.data?.isCanceled);
  const disabled = !isEditable || isCanceled;
  const visibleFields = fields
    .map((field, idx) => ({ field, idx }))
    .filter(({ idx }) => !watchedValues[idx]?.deleteFlag);

  const handleDelete = (idx) => {
    const rowId = watchedValues[idx]?.id;

    if (!rowId) {
      remove(idx);
      return;
    }

    setValue(`${fieldName}[${idx}].deleteFlag`, true, {
      shouldDirty: true,
    });
  };

  return (
    <>
      {visibleFields.map(({ field, idx }) => (
        <Grid container alignItems="center" spacing={1} key={field._id} sx={{ mb: 1 }}>
          <Grid item xs={visibleFields.length > 1 ? 11.5 : 12}>
            <StaffInfoInputs
              fieldName={`${fieldName}[${idx}]`}
              focusedField={focusedField}
              setFocusedField={setFocusedField}
              fieldAttributes={fieldAttributes}
              isEditable={isEditable}
            />
          </Grid>
          {visibleFields.length > 1 && (
            <Grid item xs={0.5}>
              <IconButton onClick={() => handleDelete(idx)} disabled={disabled} color="error">
                <DeleteOutline />
              </IconButton>
            </Grid>
          )}
        </Grid>
      ))}
      <AddMoreButton
        buttonLabel="Add more"
        handleAddMoreClick={() =>
          append({
            firstName: null,
            lastName: null,
            cellPhone: null,
            email: null,
            id: 0,
            deleteFlag: false,
          })
        }
        disabled={disabled}
      />
    </>
  );
}
